module.exports = __webpack_public_path__ + "static/media/Oracle-golden-gate-pic.8222d61d.jpg";